import level from "@/services/modules/level";
import { mapGetters } from "vuex";
import * as types from "@/store/types";
import $thousandMask from "@/mixins/thousandMask";
const VerifyChip = () =>
  import(
    /* webpackChunkName: "VerifyChip" */ "@/components/AccountPage/Personal/VerifyChip/index"
  );

const PictureVerifyChip = () =>
  import(
    /* webpackChunkName: "PictureVerifyChip" */ "@/components/AccountPage/Personal/PictureVerifyChip/index"
  );

import CoefficientTurnover from "@/components/AccountPage/Level/CoefficientTurnover/index.vue";

export default {
  name: "level",
  mixins: [$thousandMask],
  components: {
    VerifyChip,
    PictureVerifyChip,
    CoefficientTurnover
  },
  data() {
    return {
      levels: [],
      levelWithoutEdit: [],
      activeLevel: {},
      headers: [
        {
          text: this.$t("accountPage.level.level_items"),
          value: "levelItems",
          sortable: false
        }
      ],
      mobileHeaders: [
        {
          text: this.$t("accountPage.level.title"),
          value: "level",
          sortable: false
        },
        {
          text: this.$t("accountPage.level.total_withdrawal"),
          value: "pay",
          sortable: false
        },
        { text: "", value: "data-table-expand" }
      ]
    };
  },
  computed: {
    ...mapGetters({
      verifyInfo: types.userVerifyInfo.getters.GET_USER_VERIFY_INFO
    }),
    checkPhoneStatus() {
      return (
        this.verifyInfo?.home_phone_verification_status === "VERIFIED" ||
        this.verifyInfo?.home_phone_verification_status === "SUBMITTED"
      );
    },
    contactStatus() {
      return this.verifyInfo?.email_verification_status === "VERIFIED" &&
        this.verifyInfo?.mobile_verification_status === "VERIFIED" &&
        this.checkPhoneStatus
        ? "VERIFIED"
        : "REJECTED";
    },
    personalStatus() {
      return this.verifyInfo?.personal_information_status;
    },
    identityStatus() {
      if (this.verifyInfo.is_in_auto_verification) {
        if (
          this.IDCardStatus === "VERIFIED" &&
          this.videoStatus === "VERIFIED"
        ) {
          return "VERIFIED";
        } else if (
          this.IDCardStatus === "PROCESSING" ||
          this.videoStatus === "PROCESSING"
        ) {
          return "PROCESSING";
        } else {
          return "REJECTED";
        }
      } else {
        return this.verifyInfo?.verification_image.status.value;
      }
    }
  },

  mounted() {
    this.getLevelsData();
  },
  methods: {
    getLevelsData() {
      level.getLevels().then(res => {
        this.levelWithoutEdit = res.data.data;

        res.data.data.forEach(item => {
          if (item.has_user) {
            this.activeLevel = item;
          }
          this.headers.push({
            text: item.name_fa,
            value: item.name,
            sortable: false
          });

          item.rules.forEach(rule => {
            let existing = this.levels.find(l => l.levelItems === rule.name_fa);

            if (existing) {
              existing[item.name] =
                rule.total_value?.toLocaleString() ||
                this.$t("accountPage.level.unlimitedText");
            } else {
              this.levels.push({
                levelItems: rule.name_fa,
                [item.name]:
                  rule.total_value?.toLocaleString() ||
                  this.$t("accountPage.level.unlimitedText")
              });
            }
          });
        });
      });
    }
  }
};
